/**
 * Fragment URL's
 *
 * Smooth-scroll links with fragments defined as the URL value for a href attribute, ie href="#section".
 */

import jQuery from 'jquery';

jQuery( function($) {

    // Set smooth scroll offset; Get the height of the site-header. 
    var $siteheader = $('.site-header'),
        siteheader_height = 0;

    if ( $siteheader.hasClass('sticky') ) {
        
        siteheader_height = $siteheader.height();

    }

    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {

        $siteheader = $('.site-header').height();

    });

    // Find links with a URL beginning with "#".
    // TODO: Use forEach instead of jQ each().
    $( 'a[href*="#"]' ).each(function(i) {

        let $el = $(this);
        
        // Do not trigger smooth scroll on reveal (data-open), accordion (accordion-title), tabs (.tabs-title)
        if ( !$el.attr('data-open') || !$el.attr('accordion-title') || !$el.parent('.tabs-title') ) {

            new Foundation.SmoothScroll( $el, {      

                offset: siteheader_height
            
            });

        } 

    } );

} );
